import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Cell } from '../../base/styled';

import {
  SparklineWidget,
  RabbitNodeWidget,
  TableWidget,
} from '../../widgets';

const RabbitMQ = (props) => {
  const {
    title = '',
    summary: {
      error: summaryError = null,
      data: {
        'rsdvr-rabbit-total-queues': queuesSparkline = null,
        'rsdvr-rabbit-total-ready': readySparkline = null,
        'rsdvr-rabbit-0-node': nodeSparkline0 = null,
        'rsdvr-rabbit-1-node': nodeSparkline1 = null,
        'rsdvr-rabbit-2-node': nodeSparkline2 = null,
      } = {},
    } = {},
    queues: {
      error: queuesError = null,
      data: queuesTable = null,
    } = {},
  } = props;

  return (
    <div className="dashboard">
      <h2>{title}</h2>
      <Grid columns={5} rows="200px 1fr" alignContent="stretch" height="inherit">
        <Cell>
          <SparklineWidget input={{ error: summaryError, data: queuesSparkline }} />
        </Cell>
        <Cell>
          <SparklineWidget input={{ error: summaryError, data: readySparkline }} />
        </Cell>
        <Cell>
          <RabbitNodeWidget input={{ error: summaryError, data: nodeSparkline0 }} />
        </Cell>
        <Cell>
          <RabbitNodeWidget input={{ error: summaryError, data: nodeSparkline1 }} />
        </Cell>
        <Cell>
          <RabbitNodeWidget input={{ error: summaryError, data: nodeSparkline2 }} />
        </Cell>
        <Cell width={5}>
          <TableWidget input={{ error: queuesError, data: queuesTable }} />
        </Cell>
      </Grid>
    </div>
  );
};

export default RabbitMQ;

RabbitMQ.defaultProps = null;

RabbitMQ.propTypes = {
  title: PropTypes.string,
  summary: PropTypes.shape({
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    data: PropTypes.shape({
      'rsdvr-rabbit-total-queues': SparklineWidget.dataPropType,
      'rsdvr-rabbit-total-ready': SparklineWidget.dataPropType,
      'rsdvr-rabbit-0-node': RabbitNodeWidget.dataPropType,
      'rsdvr-rabbit-1-node': RabbitNodeWidget.dataPropType,
      'rsdvr-rabbit-2-node': RabbitNodeWidget.dataPropType,
    }),
  }),
  queues: PropTypes.shape(TableWidget.propTypes),
};
